import createKeyFactory, { FactoryQueryParams, KEYS } from 'utils/createKeyFactory';

const languagesFactory = {
  ...createKeyFactory([KEYS.LANGUAGES]),
  allLang: (params?: FactoryQueryParams) => [...languagesFactory.list(), 'all', ...languagesFactory.list(params)],
};

export default languagesFactory;
